@if (dialogRef) {
<div mat-dialog-title>
  @if (!error?.overlayConfig?.hideCloseButton) {
  <button
    id="close-btn"
    mat-icon-button
    mat-dialog-close
    class="close-btn"
    [title]="'ARIA_LABEL.DIALOG.CLOSE' | translate"
    [attr.aria-label]="'ARIA_LABEL.DIALOG.CLOSE' | translate"
  >
    <mat-icon>close</mat-icon>
  </button>
  }
</div>
}

<div class="content text-center">
  @if (error.image) {
  <img id="main_error_icon" class="error_img" [src]="error.image | translate" alt="" />
  } @else {
  <mat-icon id="main_error_icon" class="icon-xlg mt-11 mb-9">{{ error.icon || 'report_problem' }}</mat-icon>
  } @if (error.heading) {
  <h1 id="main_error_heading" class="mt-8">{{ error.heading | translate }}</h1>
  } @if (error.title) {
  <h2 id="main_error_title">{{ error.title | translate }}</h2>
  }
  <div id="main_error_message" class="mat-body-2 mt-4 error-message" [class.mb-24]="!error.buttons && hideCloseButton" [innerHTML]="error.message | translate"></div>

  @if (!error.buttons && !hideCloseButton) {
  <button
    class="content_main-button-list mt-40"
    mat-flat-button
    [color]="'primary'"
    [id]="'close-btn'"
    (click)="closeKonek()"
  >
    {{ 'COMMON.BUTTON.CLOSE' | translate }}
  </button>
  } @if (error.buttons && error.buttons?.length) {
  <div class="content_main-button-list mt-40">
    @for (button of error.buttons; track button; let i = $index) {
    <button mat-flat-button [color]="button.color" [id]="'error-button-' + i" (click)="onButtonClick(button)">
      {{ button.label | translate }}
    </button>
    }
  </div>
  }
</div>
